import styled from 'styled-components'

import ImageGrid from '~/features/event-info/components/ImageGrid'
import { type LocationAndScheduleInfo } from '~/features/event-info/types/event-info'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

type Props = {
  locationAndScheduleInfo: LocationAndScheduleInfo
}

function LocationAndSchedule({ locationAndScheduleInfo }: Props) {
  return (
    <Content>
      <Title>일러스타페스 장소 및 일정</Title>
      <TagBox className="center">
        <Tag $size="md" $variant="gray">
          운영 일자
        </Tag>
        <div className="desc">{locationAndScheduleInfo.event_date}</div>
      </TagBox>
      <TagBox className="center">
        <Tag $size="md" $variant={'gray'}>
          입장 시간
        </Tag>
        <div>{locationAndScheduleInfo.event_time}</div>
      </TagBox>
      <TagBox>
        <Tag $size="md" $variant={'gray'}>
          서클 참가 신청
        </Tag>
        <div>{locationAndScheduleInfo.event_application}</div>
      </TagBox>
      <TagBox>
        <Tag $size="md" $variant={'gray'}>
          주의사항
        </Tag>
        <div>{locationAndScheduleInfo.event_caution}</div>
      </TagBox>
      <ImageGrid />
    </Content>
  )
}

export default LocationAndSchedule

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  line-height: 25px;

  .desc {
    font-family: NanumSquareNeo-Regular, sans-serif;
  }

  &.center {
    align-items: center;

    @media ${theme.device.medium} {
      align-items: start;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`
